{
  "static-content-online-booking-process": {
    "buttons": {},
    "text": {
      "title": "Online buchen ist ein Kinderspiel!",
      "description": "Suchen Sie den Salon Ihrer Wahl und wählen Sie die gewünschte Dienstleistung, das Datum und die Uhrzeit. Bestätigen Sie Ihre Angaben und schon sind Sie fertig!",
      "step-confirm-title": "Das war's",
      "step-confirm-description": "Sie erhalten sofort eine Buchungsbestätigung und das war's",
      "step-find-salon-title": "Salon suchen",
      "step-find-salon-description": "Finden Sie den Salon nach Ort, Dienstleistung oder Datum",
      "step-select-date-title": "Datum und Uhrzeit auswählen",
      "step-select-date-description": "Sie können jedes verfügbare Datum und jede verfügbare Uhrzeit auswählen",
      "step-select-service-title": "Dienstleistung auswählen",
      "step-select-service-description": "Wählen Sie Ihre bevorzugte Dienstleistung"
    }
  }
}
